// ─── Thêm vào notification reducer hiện có ───────────────────────────────────
// Nếu chưa có reducer riêng thì tạo file mới:
// store/reducers/notificationReducer.js

const initialState = {
  last: null,   // notification gần nhất — DevotionReminderBannerRoot lắng nghe
  unread: 0,
}

const notificationReducer = function(state, action) {
  if (state === undefined) state = initialState

  switch (action.type) {

    case 'NOTIFICATION/RECEIVED':
      return Object.assign({}, state, {
        last:   action.payload,
        unread: (state.unread || 0) + 1,
      })

    case 'NOTIFICATION/CLEAR_LAST':
      return Object.assign({}, state, {last: null})

    case 'NOTIFICATION/MARK_READ':
      return Object.assign({}, state, {unread: 0})

    default:
      return state
  }
}

export default notificationReducer

// ─── Đăng ký vào rootReducer ─────────────────────────────────────────────────
//
// import notificationReducer from './notificationReducer'
//
// const rootReducer = combineReducers({
//     ...existing,
//     notification: notificationReducer,   ← thêm dòng này
// })